/*
 * Cesera Sticky-CTA — blendet den Mobile-Balken ein, sobald der Haupt-CTA (Sentinel)
 * nach oben aus dem Viewport gescrollt ist; blendet ihn am Footer wieder aus, damit er
 * keine Footer-/FAQ-Links verdeckt. Auf Produktseiten löst der Button die echte
 * Add-to-Cart-Aktion aus (variantensicher, nutzt Dawns Cart-Drawer).
 */
(function () {
  var bar = document.querySelector('[data-cesera-sticky]');
  if (!bar) return;

  var mobileMQ = window.matchMedia('(max-width: 749px)');
  var sentinel = document.querySelector(bar.getAttribute('data-sentinel'));
  var footer = document.querySelector('.footer, #shopify-section-footer, footer');

  var pastSentinel = false; // Sentinel liegt oberhalb des Viewports
  var footerVisible = false;

  function apply() {
    var show = mobileMQ.matches && pastSentinel && !footerVisible;
    bar.classList.toggle('is-visible', show);
  }

  if ('IntersectionObserver' in window && sentinel) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // sichtbar einblenden, sobald der Sentinel nach OBEN rausgescrollt ist
        pastSentinel = !e.isIntersecting && e.boundingClientRect.top < 0;
      });
      apply();
    }, { threshold: 0 }).observe(sentinel);
  } else if (!sentinel) {
    // Kein Sentinel gefunden → nach etwas Scrollen einblenden (Fallback).
    window.addEventListener('scroll', function () {
      pastSentinel = window.scrollY > (window.innerHeight * 0.8);
      apply();
    }, { passive: true });
  }

  if ('IntersectionObserver' in window && footer) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { footerVisible = e.isIntersecting; });
      apply();
    }, { threshold: 0 }).observe(footer);
  }

  mobileMQ.addEventListener('change', apply);

  // Produktseite: Klick an die echte ATC delegieren (respektiert gewählte Variante).
  var addBtn = bar.querySelector('[data-cesera-sticky-add]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var realSubmit = document.querySelector('.product-form__submit');
      if (realSubmit) {
        realSubmit.click();
      } else {
        var form = document.querySelector('.product-form__buttons');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    // Preis im Balken bei Variantenwechsel spiegeln (Dawn aktualisiert .price).
    var priceEl = bar.querySelector('[data-cesera-sticky-price]');
    if (priceEl) {
      var syncPrice = function () {
        var live = document.querySelector('.price:not(.price--sold-out) .price-item--regular, .price__regular .price-item--regular');
        if (live && live.textContent.trim()) priceEl.textContent = live.textContent.trim();
      };
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-selects, .product-form')) {
          window.setTimeout(syncPrice, 120);
        }
      });
    }
  }

  apply();
})();
